// @flow
import i18n from "i18next";
import k from "src/i18n/keys";

import React, { Fragment, useState, useCallback } from "react";
import Link from "redux-first-router-link";
import { useDispatch, useSelector } from "react-redux";
import { IconButton, Button } from "@chakra-ui/react";

import {
  ForgotPasswordForm,
  AuthHeader,
  AuthInfoText,
  ErrorText,
} from "src/styles/auth";
import * as styles from "src/styles/auth";
import { forgotPassword } from "src/actions/auth";
import { getSignInError, getSignInEmail } from "src/reducers";
import NavLinks from "src/components/auth/NavLinks";
import Icon from "src/icons";
import { Input } from "@unifize/sarah";

const ForgotPassword = () => {
  const dispatch = useDispatch();
  const error = useSelector((state) =>
    getSignInError("forgotPassword")(state.app),
  );
  const currentUserEmail = useSelector((state) => getSignInEmail(state.app));
  const [email, setEmail] = useState(currentUserEmail || "");

  const handleChange = useCallback((e) => {
    setEmail(e.target.value);
  }, []);

  const handleSubmit = useCallback(
    (e) => {
      e.preventDefault();
      dispatch(forgotPassword(email));
    },
    [dispatch, email],
  );

  return (
    <Fragment>
      <ForgotPasswordForm onSubmit={handleSubmit}>
        <AuthHeader>
          <Link tabIndex="-1" to="/signin">
            <IconButton mr={2} icon={<Icon type="back" />} />
          </Link>
          {i18n.t(k.FORGOT_YOUR_PASSWORD)}
        </AuthHeader>

        <AuthInfoText>{i18n.t(k.ENTER_THE_EMAIL_ADDRESS_YOU_US)}</AuthInfoText>

        <Input
          autoFocus
          type="email"
          value={email}
          placeholder={i18n.t(k.EMAIL_PLACEHOLDER)}
          name="email"
          onChange={handleChange}
          required
        />

        {error && <ErrorText>{error.message}</ErrorText>}

        <Button variant="uPrimary" sx={styles.AuthButton} type="submit">
          {i18n.t(k.SEND_LINK)}
        </Button>
      </ForgotPasswordForm>
      <NavLinks />
    </Fragment>
  );
};

export default ForgotPassword;
